import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const RedirectURLSetting: FormizoSchema[] = [
  {
    label: "Redirect URL",
    name: "SettingDoc.Content",
    format: "array",
    array: [
      {
        label: "Category",
        name: "Category",
        format: "textarea",
        rows: 2,
      },
      {
        label: "EN URL",
        name: "URL.EN",
        format: "textarea",
        rows: 2,
      },
      {
        label: "TC URL",
        name: "URL.TC",
        format: "textarea",
        rows: 2,
      },
      {
        label: "SC URL",
        name: "URL.SC",
        format: "textarea",
        rows: 2,
      },
      {
        label: "With SessionID?",
        name: "SessionIDSwitch",
        format: "bool",
        boolStyle: "switch",
      },
    ],
  },
];
